import React, { useEffect } from 'react'
import { NavLink } from 'react-router-dom';
import ScrollToTopButton from './ScrollToTopButton';

const Service = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return (
        <>
            <div className='services-mainsection'>
            <ScrollToTopButton />
                <div className='container-fluid'>
                    <div className='aboutus-bgsection'>
                        <div className='container'>
                            <h2 className='aboutus-header'>Services</h2>
                            <div>
                                <h3 className='pages-head'> <NavLink to={'/'} className="about-s">HOME</NavLink> <img className='' src='../assets/images/icon_rightabout.png' alt='arrow' />Services</h3>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='services-section'>
                    <div className='container'>
                        <div className='row'>
                        <div className='col-md-4'>
                                <NavLink style={{ textDecoration: 'none' }} to={'/Cloud-Services'} state={{ header: 'Data Algorithm' }}>
                                    <div className='services-boxsec'>
                                        <img className='services-boximg' src='../assets/images/services/CloudComputing.png' alt='Software Development' />
                                        <h3 className='services-boxhead'>Cloud Services</h3>
                                        <p className='services-boxtxt'>Data algorithm of your web data
                                            of your company website, so we
                                            help to ensure cyber</p>
                                        <NavLink style={{ textDecoration: 'none' }}> <p className="services-boxreadmore">Learn more <span><img src='../assets/images/icons/Icon_arrow_rightblack.png' alt='arrow' /></span></p></NavLink>
                                    </div>
                                </NavLink>
                            </div>
                            <div className='col-md-4'>
                                <NavLink style={{ textDecoration: 'none' }} to={'/Software-Development'} state={{ header: 'Software Development' }}>
                                    <div className='services-boxsec'>
                                        <img className='services-boximg' src='../assets/images/services/SoftwareDevelopment.png' alt='Software Development' />
                                        <h3 className='services-boxhead'>Software Development</h3>
                                        <p className='services-boxtxt'>Software development of web data
                                            of your company website, so we help to ensure cyber company</p>
                                        <NavLink style={{ textDecoration: 'none' }}> <p className="services-boxreadmore">Learn more <span><img src='../assets/images/icons/Icon_arrow_rightblack.png' alt='arrow' /></span></p></NavLink>
                                    </div>
                                </NavLink>
                            </div>
                            <div className='col-md-4'>
                                <NavLink style={{ textDecoration: 'none' }} to={'/Cyber-Security'} state={{ header: 'Cyber Security' }}>
                                    <div className='services-boxsec'>
                                        <img className='services-boximg services-boximg1' src='../assets/images/services/CyberSecurity.png' alt='Software Development' />
                                        <h3 className='services-boxhead'>Cyber Security</h3>
                                        <p className='services-boxtxt'>Cyber security of your web data
                                            of your company website, so we
                                            help to ensure cyber</p>
                                        <NavLink style={{ textDecoration: 'none' }}> <p className="services-boxreadmore">Learn more <span><img src='../assets/images/icons/Icon_arrow_rightblack.png' alt='arrow' /></span></p></NavLink>
                                    </div>
                                </NavLink>
                            </div>
                           
                        </div>
                        <div className='row'>
                        <div className='col-md-4'>
                                <NavLink style={{ textDecoration: 'none' }} to={'/QA-Services'} state={{ header: 'Cloud Computing' }}>
                                    <div className='services-boxsec'>
                                        <img className='services-boximg' src='../assets/images/services/DataAlgorithm2.png' alt='Software Development' />
                                        <h3 className='services-boxhead'>QA Services</h3>
                                        <p className='services-boxtxt'>QA service of data
                                            of your company website, so we help to ensure cyber company</p>
                                        <NavLink style={{ textDecoration: 'none' }}> <p className="services-boxreadmore">Learn more <span><img src='../assets/images/icons/Icon_arrow_rightblack.png' alt='arrow' /></span></p></NavLink>
                                    </div>
                                </NavLink>
                            </div>
                            <div className='col-md-4'>
                                <NavLink style={{ textDecoration: 'none' }} to={'/Artificial-Intelligence'} state={{ header: 'Data Management' }}>
                                    <div className='services-boxsec'>
                                        <img className='services-boximg' src='../assets/images/services/DataManagement.png' alt='Software Development' />
                                        <h3 className='services-boxhead'>Artificial Intelligence</h3>
                                        <p className='services-boxtxt'>Data management of your web data
                                            of your company website, so we
                                            help to ensure cyber</p>
                                        <NavLink style={{ textDecoration: 'none' }}> <p className="services-boxreadmore">Learn more <span><img src='../assets/images/icons/Icon_arrow_rightblack.png' alt='arrow' /></span></p></NavLink>
                                    </div>
                                </NavLink>
                            </div>
                           
                            {/* <div className='col-md-4'>
                                <NavLink style={{ textDecoration: 'none' }} to={'/Services-Details'} state={{ header: 'Chatbot Service' }}>
                                    <div className='services-boxsec'>
                                        <img className='services-boximg' src='../assets/images/services/ChatbotService.png' alt='Software Development' />
                                        <h3 className='services-boxhead'>Chatbot Service</h3>
                                        <p className='services-boxtxt'>Chatbot responding service of data
                                            of your company website, so we help to ensure cyber company</p>
                                        <NavLink style={{ textDecoration: 'none' }}> <p className="services-boxreadmore">Learn more <span><img src='../assets/images/icons/Icon_arrow_rightblack.png' alt='arrow' /></span></p></NavLink>
                                    </div>
                                </NavLink>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Service;